"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTriggerOrderChangeWsObservable = exports.getPositionModeChangeWsObservable = exports.getIsolatedModeChangeWsObservable = exports.getLeverageChangeWsObservable = exports.getAccountWebSocket = exports.DataType = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
var DataType;
(function (DataType) {
    // 合约杠杆变更
    DataType["leverage"] = "leverage";
    // 合约保证金模式变更
    DataType["isolated_mode"] = "isolated_mode";
    // 合约仓位模式变更
    DataType["position_mode"] = "position_mode";
    /**条件单 */
    DataType["pionex_trigger"] = "pionex_trigger";
})(DataType = exports.DataType || (exports.DataType = {}));
function getAccountWebSocket() {
    return new rxjs_1.Observable((subscriber) => {
        const subscription = (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccountWebSocket()
            .getAllDataObservable()
            .subscribe({
            next: (next) => {
                subscriber.next(next);
            },
            error: (err) => {
                subscriber.error(err);
            }
        });
        // Observable结束的时候，同时 unsubscribe subscription
        subscriber.add(subscription);
    });
}
exports.getAccountWebSocket = getAccountWebSocket;
// 杠杆变更推送WebSocket
function getLeverageChangeWsObservable() {
    return getAccountWebSocket().pipe((0, operators_1.filter)((msg) => msg.channel === DataType.leverage), (0, operators_1.map)((msg) => ({
        leverage: Number(msg.data.leverage),
        symbol: msg.data.symbol,
    })));
}
exports.getLeverageChangeWsObservable = getLeverageChangeWsObservable;
// 保证金模式变更推送WebSocket
function getIsolatedModeChangeWsObservable() {
    return getAccountWebSocket().pipe((0, operators_1.filter)((msg) => msg.channel === DataType.isolated_mode), (0, operators_1.map)((msg) => msg.data));
}
exports.getIsolatedModeChangeWsObservable = getIsolatedModeChangeWsObservable;
// 仓位模式变更推送WebSocket
function getPositionModeChangeWsObservable() {
    return getAccountWebSocket().pipe((0, operators_1.filter)((msg) => msg.channel === DataType.position_mode), (0, operators_1.map)((msg) => msg.data.position_mode));
}
exports.getPositionModeChangeWsObservable = getPositionModeChangeWsObservable;
// 条件单变更推送WebSocket
function getTriggerOrderChangeWsObservable() {
    return getAccountWebSocket().pipe((0, operators_1.filter)((msg) => msg.channel === DataType.pionex_trigger), (0, operators_1.map)((res) => res.data));
}
exports.getTriggerOrderChangeWsObservable = getTriggerOrderChangeWsObservable;
